/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanAccountDetailOutputDto { 
    id?: number;
    accountsType?: string | null;
    accountNumber?: string | null;
    accountCode?: string | null;
    balance?: number;
    name?: string | null;
    isDefault?: boolean;
    typeId?: number;
    typeName?: string | null;
}

